import LocationInput from './location-input';
import {
	AutofillPostcode,
	_t,
	startBarkV2,
	bugsnagClientNotify,
} from '@bark/bark-core';

/**
 * InitiateNewBark
 * @param {object} defaultOptions
 * @returns {any}
 */
export default function (defaultOptions = {}) {
	let options = $.extend(
		{
			buttonSelector: '.js-initiate-new-bark',
			categoryId: null,
			categoryName: null,
			locationId: null,
			locationName: null,
			locationType: null,
			showCategoryIfHasDefaults: false,
			showLocationIfHasDefaults: false,
		},
		defaultOptions,
	);

	/**
	 * Show the modal which the user uses to select their category and location
	 */
	const showSelectionModal = (e) => {
		const modal = $('#initiate-new-bark-modal');
		const locationInput = $('#initiate-new-bark-location');

		let showCategorySelector = true;
		let showLocationSelector = true;

		$('#category_id, #category_name_hidden').val('');
		$('#postcode_id, #postcode_type').val(-1);
		let barkMode = $(e.currentTarget).data('bark-mode');
		// ensure that  the bark-mode value is always set, with a helpful default if we don't have one provided
		if (barkMode || !$('#bark_mode').val()) {
			$('#bark_mode').val(barkMode ?? 'new-bark-button');
		}

		$('input', modal)
			.data({ streamcompleteItem: null, selected: null })
			.each((_, element) => {
				let t = $(element);
				const streamComplete = t.data('streamcomplete');

				t.val('');

				if (streamComplete) {
					t.streamComplete('clearValue');
					streamComplete.results = [];
				}
			});

		if (options.categoryId) {
			if (!options.showCategoryIfHasDefaults) {
				showCategorySelector = false;
			}

			$('#initiate-new-bark-category').streamComplete('setValue', {
				id: options.categoryId,
				value: options.categoryName,
				streamcompleteItem: {
					id: options.categoryId,
					value: options.categoryName,
				},
			});
		}

		if (options.locationId) {
			if (options.locationType) {
				if (!options.showLocationIfHasDefaults) {
					showLocationSelector = false;
				}

				locationInput.val(options.locationName).data({
					selected: {
						id: options.locationId,
						name: options.locationName,
						type: options.locationType,
					},
				});

				if (locationInput.data('streamcomplete')) {
					locationInput.streamComplete('setValue', {
						id: options.locationId,
						value: options.locationName,
						streamcompleteItem: {
							id: options.locationId,
							value: options.locationName,
						},
					});
				}
			} else {
				console.error(
					`InitBark: ${options.buttonSelector} initialised with a default location ID but no default location type`,
				);
			}
		}

		$('.js-error-text', modal).addClass('d-none');

		$('.js-init-new-bark-category-container')[
			showCategorySelector ? 'removeClass' : 'addClass'
		]('d-none');
		$('.js-init-new-bark-location-container')[
			showLocationSelector ? 'removeClass' : 'addClass'
		]('d-none');

		AutofillPostcode('#initiate-new-bark-location');

		modal.modal('show');
	};

	/**
	 * From a data set, set the input values that are used to place a Bark
	 * @param {object} data
	 */
	const setInputValues = (data) => {
		for (let key in data) {
			$(`#${key}`).val(data[key]);
		}
	};

	/**
	 * Begin the true create Bark journey
	 */
    const beginJourney = () => {
        const locationElem = $('#initiate-new-bark-location');
        const {showLoading, hideLoading, createBark} = window.Bark;
        const {id: locationId, type: locationType} = locationElem.data('selected') || {};
        const {id, name} =
        $('#initiate-new-bark-category').data('streamcompleteItem') || {};
        const payload = {
            category_id: id,
            category_name: name,
            category_name_hidden: name,
            postcode_id: locationId || -1,
            postcode_type: locationType || -1,
            postcode_name: locationElem.val().trim(),
            bark_mode: $('#bark_mode').val() ?? null,
        };
        const modal = $('#initiate-new-bark-modal');

        if (!validateCreateBarkPayload(payload)) {
            return false;
        }

        setInputValues(payload);
        modal.modal('hide');

        return startBarkV2({
            locationData: {
                id: locationId,
                type: locationType,
            },
            category_id: id,
            origin: payload.bark_mode,
            bark_mode: payload.bark_mode,
            country_id: window.Bark.ENV.ccid,
            campaign: window.Bark.ENV.campaign,
        });
    };

	/**
	 * Validate the payload used to show the create bark modal
	 * @returns {boolean}
	 */
	const validateCreateBarkPayload = ({
		category_id,
		postcode_id,
		postcode_type,
		postcode_name,
	}) => {
		const modal = $('#initiate-new-bark-modal');
		const errorContainer = $('.js-error-text', modal);
		let errorMsg;

		if (!category_id) {
			errorMsg = _t('buyer_create-bark:select-a-service');
		}

		if (!errorMsg && +postcode_id !== -1 && +postcode_type === -1) {
			errorMsg = _t('buyer_create-bark:select-a-location');
		}

		if (!errorMsg && postcode_name && +postcode_id === -1) {
			errorMsg = _t('buyer_create-bark:select-a-location');
		}

		if (errorMsg) {
			errorContainer.text(errorMsg).removeClass('d-none');
			$('input', modal)
				.off('input.hideError')
				.on('input.hideError', () => {
					errorContainer.addClass('d-none');
				});
			return false;
		}

		return true;
	};

	/**
	 * Bind events
	 * @returns {this}
	 */
	const bind = () => {
		$(options.buttonSelector)
			.off('click.initNewBark')
			.on('click.initNewBark', showSelectionModal);
		$('body')
			.off('click.reactInitNewBark')
			.on('click.reactInitNewBark', 'button.__btnPlaceRequest', showSelectionModal);

		const categoryComplete = streamComplete(
			'#initiate-new-bark-category',
			'services',
			'GET',
			(item) => {
				$('#initiate-new-bark-category').data({ selected: item });
			},
		);

		categoryComplete.s.onbeforesearch = (payload) => {
			payload.coid = window.Bark.ENV.ccid;
			$('#initiate-new-bark-category').data({ selected: null, streamcompleteItem: null });
		};

		LocationInput({
			selector: '#initiate-new-bark-location',
			onBeforeSearch: (payload) => {
				$('#initiate-new-bark-location').data({ selected: null });
			},
			onSelect: (item) => {
				$('#initiate-new-bark-location').data({ selected: item });
			},
			countryCode: Bark && Bark.ENV && Bark.ENV.locale,
		});

		$('.js-init-new-bark-begin')
			.off('click.continueToPlaceBark')
			.on('click.continueToPlaceBark', beginJourney);
	};

	/**
	 * Update the options for this object
	 * @param {object} newOptions
	 */
	const updateOptions = (newOptions) => {
		options = $.extend(options, newOptions);
	};

	return {
		bind,
		updateOptions,
	};
}
